import { enqueueSnackbar } from "notistack"
import { CheckDriverEmailResponse } from "../../types/driverTypes"
import { api } from "./apiConfig"

export async function getDrivers(memberId: number): Promise<any> {
  try {
    const response = await api.get(
      `/GetUser/GetAllDrivers?memberId=${memberId}`,
    )

    return response.data
  } catch (error) {
    console.error("There was an error!", error)
    throw new Error("There was an error!")
  }
}

export async function checkDriverEmail(
  email: string,
  memberId: number,
): Promise<CheckDriverEmailResponse> {
  try {
    const response = await api.post("/GetUser/CheckDriverEmail", {
      email,
      memberId,
    })

    return response.data
  } catch (error) {
    console.error("There was an error!", error)
    throw new Error("There was an error!")
  }
}

export async function addDriverDetails(
  email: string,
  firstName: string,
  lastName: string,
  phone: string,
  memberId: number,
): Promise<any> {
  const reqData = { email, firstName, lastName, mobilePhone: phone, memberId }
  try {
    const response = await api.post("/GetUser/AddDriverDetails", reqData)

    return response.data
  } catch (error) {
    console.error("There was an error!", error)
    throw new Error("There was an error!")
  }
}

export async function getDriverTokens(token: string): Promise<any> {
  try {
    const response = await api.post("/Security/ActionSiteLogin", {
      encryptedPayload: token,
    })

    return response.data[0]
  } catch (error) {
    console.error("There was an error!", error)
    throw new Error("There was an error!")
  }
}

export async function uploadDocument(
  reqData: any,
  token: string,
  customerToken: string,
): Promise<any> {
  try {
    const headers = {
      "x-Token": token,
      "x-Customer": customerToken,
    }
    const response = await api.post("/Global/Document", reqData, {
      headers,
    })

    return response.data
  } catch (error) {
    console.error("There was an error!", error)
    throw new Error("There was an error!")
  }
}

export async function disconnectDriver(
  reqData: { driverId: number; disconnect: boolean },
  token: string,
  customerToken: string,
): Promise<any> {
  try {
      const headers = {
      "x-Token": token,
      "x-Customer": customerToken,
    }
    const response = await api.post("/GetUser/DisconnectSubDriver", reqData, {
      headers,
    })
    enqueueSnackbar("Success", { variant: "success" });
    return response.data
  } catch (error) {
    if (error instanceof Error) {
      enqueueSnackbar(error.message, { variant: "error" });
    } else {
      enqueueSnackbar("error", { variant: "error" });
    }
    throw new Error("There was an error!")
  }
}

export async function completeAddDriver(
  reqData: any,
  token: string,
  customerToken: string,
): Promise<any> {
  try {
    const headers = {
      "x-Token": token,
      "x-Customer": customerToken,
    }
    const response = await api.post("/GetUser/FinishAddSubDriver", reqData, {
      headers,
    })

    return response.data
  } catch (error) {
    console.error("There was an error!", error)
    throw new Error("There was an error!")
  }
}
